export default "__VITE_ASSET__BXMgQ3NL__"